<template>
    <div style="display: flex; justify-content: center; align-items: center; height: 80vh; flex-direction: column;">
        <a-result status="warning" />
        <div style="text-align: center; font-size:medium; margin-top: -50px;" >
            <div>เกิดปัญหาบางประการกับการทำงานของระบบ กรุณารีเฟรชหน้าใหม่ หากยังคงพบปัญหาอยู่ กรุณาติดต่อทีมเทคโนโลยีเพื่อขอความช่วยเหลือ</div>
            <div>An issue has occurred with the system. Please refresh the page, and if the problem persists, contact the technology support team for assistance.</div>
        </div>
    </div>
</template>